import * as signalR from '@microsoft/signalr'
import "@babel/polyfill"
import React, { useState, useEffect, useRef, useContext } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { matchPath, useHistory } from 'react-router-dom'
import "./App.scss"
import { SignIn } from './components/account/SignIn'
import { Layout } from './components/Layout'
import { actionCreators } from './store/Auth.ts'
import { gaUserSet, gaInit, gaPageView } from './utils/react-ga'
import { MsalProvider } from '@azure/msal-react'
import { UrlString } from '@azure/msal-common'
import { msalInstance } from './globals'
import { ThemeContext } from './ThemeProvider'

export default function App() {
  const INACTIVITY_TIME_LIMIT = Number(process.env.REACT_APP_APP_TIMEOUT_IN_MIN) || 60
//   console.log("⏳ Timeout value:", INACTIVITY_TIME_LIMIT)
//   console.log("⏳ NUMBER:", process.env.REACT_APP_APP_TIMEOUT_IN_MIN)
//   console.log("⏳ Calculated timeout (ms):", INACTIVITY_TIME_LIMIT * 60 * 1000)
//   console.log('NODE_ENV', process.env.NODE_ENV)

  const [isTimedOut, setIsTimedOut] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  const storedTheme = localStorage.getItem('theme') || 'light'
  const { theme } = useContext(ThemeContext)

  const history = useHistory()
  const dispatch = useDispatch()

  const timeoutRef = useRef(null)
  const auth = useSelector(state => state.auth)
  // Use token from backend response or MSAL account as fallback
  const authenticated = auth?.token?.length > 0 || msalInstance.getActiveAccount() != null
  const user = useSelector(state => state?.auth?.user)
  const location = useSelector(state => state?.router?.location)


  const storeCurrentPage = () => {
    sessionStorage.setItem('redirectPath', window.location.pathname + window.location.search)
  }

  const getUrlRoot = () => {
    const match = matchPath(history.location.pathname, { path: '/:a', strict: false })
    return match !== null ? match.params.a : null
  }

  useEffect(() => {
    const resetTimer = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
      timeoutRef.current = setTimeout(() => {
        setIsTimedOut(true)
      }, INACTIVITY_TIME_LIMIT * 60 * 1000)
    }

    if (authenticated) {
      resetTimer()
      document.addEventListener('mousemove', resetTimer)
      document.addEventListener('keypress', resetTimer)
      document.addEventListener('click', resetTimer)
      document.addEventListener('scroll', resetTimer)
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
      document.removeEventListener('mousemove', resetTimer)
      document.removeEventListener('keypress', resetTimer)
      document.removeEventListener('click', resetTimer)
      document.removeEventListener('scroll', resetTimer)
    }
  }, [authenticated])


  useEffect(() => {
    if (isTimedOut) {
      storeCurrentPage()
      localStorage.removeItem('auth')
      localStorage.clear()
      dispatch(actionCreators.logoutUser())
      gaInit()
      setIsTimedOut(false)
      history.push('/')
    }
  }, [isTimedOut, dispatch, history])

  useEffect(() => {
    if (authenticated) {
      const redirectPath = sessionStorage.getItem('redirectPath')
      if (redirectPath) {
        sessionStorage.removeItem('redirectPath')
        history.replace(redirectPath)
      }
      setIsLoading(false)
    } else {
      setIsLoading(false)
    }
  }, [authenticated, history])

  useEffect(() => {
    if (authenticated && user?.id) {
      gaUserSet(user.id)
    }
    if (location?.pathname) {
      gaPageView(location.pathname)
    }
  }, [authenticated, user, location])

  const isAuthPopup = () => {
    const hash = window.location.hash
    return UrlString.hashContainsKnownProperties(hash)
  }

  if (isLoading) {
    return <div>Loading...</div>
  }

  if (isAuthPopup()) {
    return (
      <div>
        <h1>Authenticating...</h1>
      </div>
    )
  }

  return (
    <MsalProvider instance={msalInstance}>
      <div className={`app ${theme}`}>
        {authenticated ? <Layout /> : <SignIn />}
      </div>
    </MsalProvider>
  )
}